import React from "react";
import { Link } from "react-router-dom";
import logo from "../static/img/logo.png";
import "../static/css/AdminNav.css";

function AdminNav() {
  return (
    <>
      <div className="admin-Nav">
        <div className="adminNav-title">
          <img src={logo} alt="SKP & Co" />
        </div>
        <div className="adminNav-button">
          <Link to="/admincontrol">Admin Users</Link>
          <Link to="/adminpublications">Publications</Link>
          <Link to="/adminschedule">Scheduling</Link>
          <Link to="/admingallery">Gallery</Link>
          <Link to="/adminteam">Team Members</Link>
        </div>
      </div>
    </>
  );
}

export default AdminNav;
